import { DITypes } from "@/core/@types/types";
import { AxiosAdapter } from "../../core/services/AxiosAdapter";
import { baseURL } from "../../core/services/protocols";
import { injectable, inject, optional } from "inversify";
import type { IEvent } from "@/core/plugins/Events/Event";
import type { IHttpTokenInterceptor } from "../../core/services/middleware/HttpTokenInterceptor";
import type { AxiosInstance } from "axios";

@injectable()
export default class ContabilHttpClient extends AxiosAdapter {
  constructor(
    @inject(DITypes.EVENT) event: IEvent,
    @inject(DITypes.INTERCEPTOR)
    @optional()
    axiosTokenInterceptor?: IHttpTokenInterceptor<AxiosInstance>
  ) {
    super(event, axiosTokenInterceptor);

    this.setup(baseURL);
  }
}
